import $ from 'jquery';

export default function () {

    $(document).on('click', 'a', function () {
        if (!window.ga) {
            return false;
        }

        const ga = window.ga;

        const GaAction = $(this).data('event-action');

        if (GaAction === 'Share:Facebook') {
            ga('send', 'social', 'Facebook', 'share', location.href);
            return ga('rollup.send', 'social', 'Facebook', 'share', location.href);
        }

        if (GaAction === 'Share:Twitter') {
            ga('send', 'social', 'Twitter', 'tweet', location.href);
            return ga('rollup.send', 'social', 'Twitter', 'tweet', location.href);
        }

        if (GaAction === 'Share:Linkedin') {
            ga('send', 'social', 'Linkedin', 'share', location.href);
            return ga('rollup.send', 'social', 'Linkedin', 'share', location.href);
        }

        if (GaAction === 'Share:Email') {
            ga('send', 'social', 'Email', 'email', location.href);
            return ga('rollup.send', 'social', 'Email', 'email', location.href);
        }

        if (GaAction === 'Clicked: Announcement') {
            ga('send', 'event', 'User', 'Clicked: Announcement', 'Google IO');
            return ga('rollup.send', 'event', 'User', 'Clicked: Announcement', 'Google IO');
        }
    });

}
